import { render, staticRenderFns } from "./pwaDialog.vue?vue&type=template&id=0c03dd67&"
import script from "./pwaDialog.vue?vue&type=script&lang=js&"
export * from "./pwaDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports